import Vue from '@/main'
const getters = {
  openId: state => state.app.openId,
  currDate: state =>state.app.currDate,
  currDateMonth: state => {
    return state.app.currYm.replace('-','/')
  },
  currYm: state => state.app.currYm,
  currClient: state => state.app.currClient,
  currClientDetail: state => state.app.currClientDetail,
  smallScale: state => {
    if(Vue.$dict){
      return Vue.$dict[state.app.currClientDetail.tax_id].name.includes('小规模') 
    }else{
        return   state.app.currClientDetail.tax_id===150
    }
  
  },
  clientList: state => state.app.clientList,
  currInvoice: state => state.invoice.currInvoice,
  hasErr: state => state.app.hasErr,
  errMsg: state => state.app.errMsg
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js